import type { PcMonitorPriceHistoryEntry } from '../../types/pcmonitor.ts';
import { formatChf, latestPriceDrop } from './listingMath.ts';

interface PriceDropProps {
  history: PcMonitorPriceHistoryEntry[];
}

/**
 * Drop indicator: shown when the latest observed price is below a previous
 * one. Green because a drop is a buying signal for the operator.
 */
export default function PriceDrop({ history }: PriceDropProps) {
  const drop = latestPriceDrop(history);
  if (!drop) return <span className="text-gray-300">—</span>;
  return (
    <span
      className="inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 whitespace-nowrap"
      title={`Dropped from ${formatChf(drop.from)}`}
    >
      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5L12 21m0 0l-7.5-7.5M12 21V3" />
      </svg>
      {formatChf(drop.drop)}
    </span>
  );
}
